import React from "react";
import {FooterItem, FooterWrapper, FooterSocials} from "./FooterElements";
import {NavLinks, NavRouterLinks} from "../navbar/NavBarElements";
import {FaFacebook, FaInstagram} from "react-icons/fa";
import logo from "../../images/ps_white_logo_small.png"

const Footer = () => {
    return (
        <>
            <FooterWrapper>
                <FooterItem>
                    <NavRouterLinks to='/'><img src={logo} alt="logo" /></NavRouterLinks>
                </FooterItem>
                <FooterItem>
                    <NavRouterLinks to='/work'>PROJECTS</NavRouterLinks>
                </FooterItem>
                <FooterItem>
                    <NavRouterLinks to='/about'>ABOUT</NavRouterLinks>
                </FooterItem>
                <FooterItem>
                    <NavRouterLinks to='/contact'>CONTACT</NavRouterLinks>
                </FooterItem>
                <FooterItem>
                    <FooterSocials>
                        <NavLinks
                            href={"https://www.instagram.com/progress.studio.uk"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaInstagram />
                        </NavLinks>
                        <NavLinks
                            href={"https://www.facebook.com/progress.studio.uk"}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <FaFacebook />
                        </NavLinks>
                    </FooterSocials>
                </FooterItem>
            </FooterWrapper>
        </>
    )
}


export default Footer;
